import gql from 'graphql-tag';
import { scheduledSessionFieldsFragment } from '../fragments';

export const removeParticipantFromScheduledSessionMutation = gql`
  mutation RemoveParticipantFromScheduledSession($id: ID!, $participant: ID!) {
    removeParticipantFromScheduledSession(id: $id, participant: $participant) {
      ... on ScheduledSession {
        ...AdminScheduledSessionFields
      }
      ... on RemoveObjectConfirmationResponse {
        references { id, type, title, canBeSafelyRemoved }
      }
    }
  }

  ${scheduledSessionFieldsFragment}
`